import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import React, { useEffect, useState, useRef } from "react";
import { Entypo } from "@expo/vector-icons";

import Block from "../Firestore/Block";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import { v4 as uuidv4 } from "uuid";
import Fonts from "../../Resources/Fonts";
import { Ionicons } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";

import { Octicons } from "@expo/vector-icons";
import { observer, Observer } from "mobx-react";

import { useTranslation } from "react-i18next";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";

import { MaterialIcons } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../_layout";
import { ProtocolTitles } from "../../Resources/Constants";
import IconEmptyView from "../Components/IconEmptyView";

const BlockOverview = observer(({ block }) => {
  const { t, i18n } = useTranslation();

  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const hideBlockDashboard = block.client?.coach?.hideBlockDashboard ?? false;

  const OverviewFeatureOverlay = () => {
    return (
      <View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 24,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          borderBottomLeftRadius: 14,
          borderBottomRightRadius: 14,
          zIndex: 5,
          borderRadius: 14,
        }}
        pointerEvents="box-only"
      >
        <View
          style={{
            alignItems: "center",
            padding: 32,
            backgroundColor: Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            borderColor: Colors.borderColor,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 8,
            elevation: 3,
            maxWidth: 500,
          }}
          pointerEvents="auto"
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
              paddingHorizontal: 10,
              paddingVertical: 4,
              borderRadius: 10,
              backgroundColor: "rgba(63, 123, 141, 0.1)",
              marginBottom: 16,
            }}
          >
            <Ionicons
              name="information-circle-outline"
              size={16}
              color={Colors.bubbleColor}
            />
            <Text
              style={{
                fontSize: 12,
                color: Colors.bubbleColor,
                fontWeight: "500",
              }}
            >
              {t("optionalFeature-string")}
            </Text>
          </View>
          <Text
            style={{
              fontSize: 16,
              fontWeight: "600",
              marginBottom: 12,
              color: Colors.blackColor,
              textAlign: "center",
            }}
          >
            {t("blockOverview-string")}
          </Text>
          <Text
            style={{
              fontSize: 13,
              color: Colors.darkgrayColor,
              textAlign: "center",
              lineHeight: 18,
            }}
          >
            {t("blockOverviewAvailableText-string")}
          </Text>
        </View>
      </View>
    );
  };

  const WeekHeader = ({ week }) => {
    return (
      <View
        style={{
          width: 264,
          alignItems: "flex-start",
          flexDirection: "row",
          marginRight: week !== block.totalWeeks ? 40 : 16,
        }}
      >
        <View style={{ alignItems: "center", width: "100%" }}>
          <View
            style={{
              maxWidth: 264,
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <Observer>
              {() => (
                <Feather
                  name={block.isWeekHidden(week) ? "eye-off" : "eye"}
                  size={14}
                  color={Colors.grayColor}
                  style={{
                    paddingRight: 8,
                    alignItems: "center",
                  }}
                />
              )}
            </Observer>

            <Observer>
              {() => (
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 13,
                    fontWeight: "500",
                    color: Colors.grayColor,
                    maxWidth: 220,
                  }}
                  numberOfLines={1}
                >
                  {block.getWeekName(week)
                    ? block.getWeekName(week)
                    : t("weekWithNumber-string", {
                        week: week,
                      })}
                </Text>
              )}
            </Observer>
          </View>

          <View
            style={{
              height: 1,
              backgroundColor: Colors.borderColor,
              width: "100%",
              marginVertical: 4,
            }}
          />

          <View
            style={[
              GlobalStyles.HStack,
              {
                width: "100%",
                // justifyContent: "space-between",
                gap: 16,
              },
            ]}
          >
            <Text
              style={{
                flex: 1,
                textAlign: "center",
                fontSize: 13,
                fontWeight: "500",
                color: Colors.grayColor,
              }}
              numberOfLines={1}
            >
              Slot
            </Text>
            <Text
              style={{
                flex: 1,
                textAlign: "center",
                fontSize: 13,
                fontWeight: "500",
                color: Colors.grayColor,
              }}
              numberOfLines={1}
            >
              {t("protocol-string")}
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const ProtocolRow = ({ protocolTitle }) => {
    const SlotOfWeek = ({ slotExercise }) => {
      const SlotText = observer(({ slotExercise }) => {
        return (
          <View
            style={{
              alignItems: "center",
              flex: 1,
            }}
          >
            {slotExercise ? (
              <>
                <Text
                  numberOfLines={2}
                  style={{
                    width: "100%",
                    color: "black",
                    textAlign: "center",
                    fontSize: screenSize === "small" ? 10 : 11,
                    padding: 4,
                  }}
                >
                  {slotExercise.getName(t, i18n.language)}
                </Text>
                {slotExercise.getSecondProtocol && (
                  <>
                    <Text
                      style={{
                        width: "100%",
                        color: "black",
                        textAlign: "center",
                        fontSize: screenSize === "small" ? 10 : 11,
                        padding: 2,
                      }}
                    >
                      +
                    </Text>
                    <Text
                      numberOfLines={2}
                      style={{
                        width: "100%",
                        color: "black",
                        textAlign: "center",
                        fontSize: screenSize === "small" ? 10 : 11,
                        padding: 2,
                      }}
                    >
                      {slotExercise.getSecondProtocol.getName(t, i18n.language)}
                    </Text>
                  </>
                )}
              </>
            ) : (
              <View
                style={{
                  width: "100%",
                  alignItems: "center",
                  borderRadius: 10,
                }}
              >
                <AntDesign name="minus" size={10} color={Colors.blackColor} />
              </View>
            )}
          </View>
        );
      });

      const ProtocolText = observer(({ slotExercise }) => {
        const ProtocolTextBox = observer(({ slotExercise }) => {
          return slotExercise.protocolText !== "" ? (
            <View
              style={{
                width: "100%",
                marginTop: slotExercise.isSecondaryProtocol ? 10 : 0,
              }}
            >
              <Text
                numberOfLines={3}
                style={{
                  width: "100%%",
                  color: "gray",
                  textAlign: "center",
                  fontSize: screenSize === "small" ? 9 : 10,
                  fontWeight: "normal",
                  padding: 2,
                }}
              >
                {slotExercise.protocolText}
              </Text>
            </View>
          ) : (
            <View
              style={{
                width: "100%",
                alignItems: "center",
                borderRadius: 10,
              }}
            >
              <AntDesign name="minus" size={10} color="gray" />
            </View>
          );
        });

        return (
          <View
            style={{
              alignItems: "center",
              flex: 1,
            }}
          >
            {slotExercise ? (
              <>
                <ProtocolTextBox slotExercise={slotExercise} />
                {slotExercise.getSecondProtocol && (
                  <ProtocolTextBox
                    slotExercise={slotExercise.getSecondProtocol}
                  />
                )}
              </>
            ) : (
              <View
                style={{
                  width: "100%",
                  alignItems: "center",
                  borderRadius: 10,
                }}
              >
                <AntDesign name="minus" size={10} color={"gray"} />
              </View>
            )}
          </View>
        );
      });

      return (
        <View
          style={{
            alignItems: "center",
            flexDirection: "row",
            width: 264,
            minHeight: 40,
          }}
        >
          <View
            style={[
              GlobalStyles.HStack,
              {
                width: "100%",
                gap: 16,
              },
            ]}
          >
            <SlotText slotExercise={slotExercise} />
            <ProtocolText slotExercise={slotExercise} />
          </View>
        </View>
      );
    };

    return (
      block.hasAnyExerciseForSlot(protocolTitle) === true && (
        <View
          style={{
            // marginTop:
            //   protocolTitle == ProtocolTitles.PRIMARY_SQUAT ||
            //   protocolTitle == ProtocolTitles.PRIMARY_BENCH_PRESS ||
            //   protocolTitle == ProtocolTitles.PRIMARY_DEADLIFT
            //     ? 0
            //     : 8,
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            paddingBottom: 8,
          }}
        >
          <View
            style={{
              width: 160,
              textAlign: "center",
              paddingHorizontal: 24,
            }}
          >
            <View
              style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 12,
                }}
                numberOfLines={3}
              >
                {t(protocolTitle)}
              </Text>
            </View>
          </View>

          {Array.from({ length: block.totalWeeks }, (_, i) => i + 1).map(
            (week) => (
              <View
                style={{
                  marginRight: week !== block.totalWeeks ? 40 : 16,
                }}
                key={week}
              >
                <SlotOfWeek
                  slotExercise={block.getSlotOfWeek(protocolTitle, week)}
                />
              </View>
            )
          )}
        </View>
      )
    );
  };

  const NotesRow = observer(() => {
    const changeNotes = (text) => {
      block.setProperty("notes", text);
    };
    const [isHovered, setIsHovered] = useState(false);

    return (
      <View style={{ width: "100%", marginVertical: 10 }}>
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              height: 50,
              justifyContent: "space-between",
              marginVertical: 10,
              paddingHorizontal: 16,
            },
          ]}
        >
          <Text
            style={{
              // width: "10%",
              textAlign: "center",
              fontSize: 11,
              fontWeight: "500",
              color: Colors.blackColor,
              paddingLeft: 16,
              paddingRight: 32,
            }}
          >
            {t("notes-string").toUpperCase()}
          </Text>
          <TextInput
            placeholder={t("notesAboutBlock-string")}
            // placeholder=""
            placeholderTextColor="gray"
            value={block.notes}
            onChangeText={changeNotes}
            multiline={true} // Allows for multiple lines
            numberOfLines={3} // Set the fixed number of lines
            textAlignVertical="top" // Aligns text to the top, useful for multiline
            scrollEnabled={true} // Enables scrolling
            style={{
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
              // width: "87%",
              flex: 1,
              borderRadius: 14,
              borderWidth: 0.5,
              color: "black",
              // textAlign: "center",
              fontSize: 11,
              padding: 10,
              height: 60, // Set a fixed height to ensure the TextInput is tall enough to accommodate 3 lines
            }}
            maxLength={1000}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </View>
        {/* <View
          style={{
            height: 1,
            backgroundColor: Colors.borderColor,
            width: "100%",
            marginTop: 5,
          }}
        /> */}
      </View>
    );
  });

  const BlockWeeklyAverages = observer(({ basicExercise }) => {
    const AverageDataRow = observer(({ stat, basicExercise }) => {
      return (
        <View style={{ width: "100%", alignItems: "center" }}>
          <View
            style={[
              GlobalStyles.HStack,
              {
                width: "100%",
                height: 24,
              },
            ]}
          >
            <View
              style={{
                // flex: 1,
                alignItems: "center",
                justifyContent: "center",
                // marginLeft: 12,
                width: 160,
                textAlign: "center",
                paddingHorizontal: 8,
              }}
            >
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 11,
                  ontWeight: "500",
                }}
                numberOfLines={3}
              >
                {t(stat)}
              </Text>
            </View>

            {Array.from({ length: block.totalWeeks }, (_, i) => i + 1).map(
              (week) => (
                <View
                  style={{
                    width: 264,
                    alignItems: "center",
                    marginRight: week !== block.totalWeeks ? 40 : 16,
                  }}
                  key={week}
                >
                  <Text
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: 11,
                      // fontWeight: "500",
                      color: Colors.blackColor,
                    }}
                  >
                    {stat === "stressIndex-string"
                      ? block.blockDashboardTotalStressIndex(
                          basicExercise,
                          week
                        )
                      : stat === "tonnage-string"
                      ? block.blockDashboardAverageTonnage(basicExercise, week)
                      : stat === "numberOfSets-string"
                      ? block.blockDashboardAverageSeries(basicExercise, week)
                      : block.blockDashboardAverageNL(basicExercise, week)}
                  </Text>
                </View>
              )
            )}
          </View>
          {stat !== "numberOfLifts-string" && (
            <View
              style={{
                height: 0.1,
                backgroundColor: Colors.borderColor,
                width: "98%",
                // marginVertical: 2,
              }}
            />
          )}
        </View>
      );
    });
    return (
      <View style={{ marginTop: 0 }}>
        <View
          style={{
            height: 0.1,
            backgroundColor: Colors.borderColor,
            width: "100%",
            marginBottom: 0,
          }}
        />
        <AverageDataRow
          stat={"stressIndex-string"}
          basicExercise={basicExercise}
        />
        <AverageDataRow stat={"tonnage-string"} basicExercise={basicExercise} />
        <AverageDataRow
          stat={"numberOfSets-string"}
          basicExercise={basicExercise}
        />
        <AverageDataRow
          stat={"numberOfLifts-string"}
          basicExercise={basicExercise}
        />
      </View>
    );
  });

  const PrimarySessions = observer(({ basicExercise }) => {
    const PrimaryDataRow = observer(
      ({ stat, statReference, basicExercise }) => {
        return (
          <View style={{ width: "100%", alignItems: "center" }}>
            <View
              style={[
                GlobalStyles.HStack,
                {
                  width: "100%",
                  height: 24,
                  // justifyContent: "space-between",
                  // paddingVertical: 10,
                },
              ]}
            >
              <View
                style={{
                  // flex: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  // marginLeft: 12,
                  width: 160,
                  textAlign: "center",
                  paddingHorizontal: 8,
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 11,
                    ontWeight: "500",
                  }}
                  numberOfLines={3}
                >
                  {t(stat)}
                </Text>
              </View>

              {Array.from({ length: block.totalWeeks }, (_, i) => i + 1).map(
                (week) => (
                  <View
                    style={{
                      width: 264,
                      alignItems: "center",
                      marginRight: week !== block.totalWeeks ? 40 : 16,
                    }}
                    key={week}
                  >
                    <Text
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: 11,
                        // fontWeight: "500",
                        color: Colors.blackColor,
                      }}
                    >
                      {block.blockPrimaryStats(
                        basicExercise,
                        statReference,
                        week
                      )}
                    </Text>
                  </View>
                )
              )}
            </View>
            {stat !== "loadIncrease-string" && (
              <View
                style={{
                  height: 0.1,
                  backgroundColor: Colors.borderColor,
                  width: "98%",
                  // marginVertical: 2,
                }}
              />
            )}
          </View>
        );
      }
    );
    return (
      <View>
        <View
          style={{
            height: 0.1,
            backgroundColor: Colors.borderColor,
            width: "100%",
            // marginVertical: 5,
          }}
        />
        <PrimaryDataRow
          stat={"bestSet-string"}
          statReference={"BestSerie"}
          basicExercise={basicExercise}
        />
        <PrimaryDataRow
          stat={"bestE1rm-string"}
          statReference={"MaxErm"}
          basicExercise={basicExercise}
        />
        <PrimaryDataRow
          stat={"loadIncrease-string"}
          statReference={"WeightIncrease"}
          basicExercise={basicExercise}
        />
      </View>
    );
  });

  const ShowStatsButton = observer(({ basicExercise }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
      <TouchableOpacity
        onPress={() =>
          block.setProperty("showingOverviewStats", !block.showingOverviewStats)
        }
        style={{
          padding: 8,
          backgroundColor: isHovered
            ? "rgba(63, 123, 141, 0.1)"
            : block.showingOverviewStats
            ? "rgba(63, 123, 141, 0.05)"
            : "rgba(63, 123, 141, 0.08)",
          borderRadius: 10,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Text
          style={{
            color: block.showingOverviewStats
              ? Colors.grayColor
              : Colors.bubbleColor,
          }}
        >
          {block.showingOverviewStats
            ? t("hideStats-string")
            : t("showStats-string")}
        </Text>
      </TouchableOpacity>
    );
  });

  return (
    <View style={{ width: "100%" }}>
      <View
        style={{
          width: "100%",
          backgroundColor: Colors.whiteColor,
          borderRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          alignItems: "center",
          position: "relative",
        }}
      >
        <Text
          style={[
            screenSize === "small" ? Fonts.bold20 : Fonts.bold22,
            { marginVertical: 16, width: "95%", zIndex: 10 },
          ]}
        >
          {t("summaryOf-string", { name: block.name })}
        </Text>

        {hideBlockDashboard && <OverviewFeatureOverlay />}

        {block.protocolsAndExercises.some((e) => !!e.protocolSlot) ? (
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            // Allow content to grow horizontally
            contentContainerStyle={{
              flexGrow: 1,
              // minWidth: contentWidth,
              paddingHorizontal: 16,
              justifyContent: "space-around",
            }}
            style={{
              width: "100%",
              opacity: hideBlockDashboard ? 0.4 : 1,
              minHeight: hideBlockDashboard ? 240 : undefined,
            }}
          >
            <View
              style={{
                alignItems: "center",
              }}
            >
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    // marginLeft: 12,
                    width: 160,
                    paddingHorizontal: 8,
                    alignItems: "center",
                  }}
                >
                  <ShowStatsButton />
                </View>
                {Array.from({ length: block.totalWeeks }, (_, i) => i + 1).map(
                  (week) => (
                    <WeekHeader week={week} key={week} />
                  )
                )}
              </View>

              {block.hasAnyExerciseForBasicExercise("squat") && (
                <View
                  style={{
                    alignItems: "center",
                    borderRadius: 14,
                    borderWidth: 0.1,
                    borderColor: Colors.borderColor,
                    paddingTop: 8,
                    marginTop: 16,
                    // gap: 8,
                  }}
                >
                  <ProtocolRow protocolTitle={ProtocolTitles.PRIMARY_SQUAT} />
                  <ProtocolRow protocolTitle={ProtocolTitles.SECONDARY_SQUAT} />
                  <ProtocolRow protocolTitle={ProtocolTitles.TERTIARY_SQUAT} />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.QUATERNARY_SQUAT}
                  />
                  <ProtocolRow protocolTitle={ProtocolTitles.QUINARY_SQUAT} />

                  {block.showingOverviewStats && (
                    <>
                      <BlockWeeklyAverages basicExercise={"squat"} />
                      <PrimarySessions basicExercise={"squat"} />
                    </>
                  )}
                </View>
              )}

              {block.hasAnyExerciseForBasicExercise("benchPress") && (
                <View
                  style={{
                    alignItems: "center",
                    borderRadius: 14,
                    borderWidth: 0.1,
                    borderColor: Colors.borderColor,
                    paddingTop: 8,
                    marginTop: 16,
                  }}
                >
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.PRIMARY_BENCH_PRESS}
                  />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.SECONDARY_BENCH_PRESS}
                  />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.TERTIARY_BENCH_PRESS}
                  />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.QUATERNARY_BENCH_PRESS}
                  />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.QUINARY_BENCH_PRESS}
                  />

                  {block.showingOverviewStats && (
                    <>
                      <BlockWeeklyAverages basicExercise={"benchPress"} />
                      <PrimarySessions basicExercise={"benchPress"} />
                    </>
                  )}
                </View>
              )}

              {block.hasAnyExerciseForBasicExercise("deadlift") && (
                <View
                  style={{
                    alignItems: "center",
                    borderRadius: 14,
                    borderWidth: 0.1,
                    borderColor: Colors.borderColor,
                    paddingTop: 8,
                    marginTop: 16,
                  }}
                >
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.PRIMARY_DEADLIFT}
                  />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.SECONDARY_DEADLIFT}
                  />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.TERTIARY_DEADLIFT}
                  />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.QUATERNARY_DEADLIFT}
                  />
                  <ProtocolRow
                    protocolTitle={ProtocolTitles.QUINARY_DEADLIFT}
                  />

                  {block.showingOverviewStats && (
                    <>
                      <BlockWeeklyAverages basicExercise={"deadlift"} />
                      <PrimarySessions basicExercise={"deadlift"} />
                    </>
                  )}
                </View>
              )}
            </View>
          </ScrollView>
        ) : (
          <View
            style={{
              alignItems: "center",
              alignSelf: "center",
              opacity: hideBlockDashboard ? 0.4 : 1,
              minHeight: hideBlockDashboard ? 240 : undefined,
            }}
          >
            <IconEmptyView
              iconLibrary={"Ionicons"}
              mainText={"emptyProtocolsTitle-string"}
              subText={"emptyProtocolsText-string"}
              iconName={"barbell-outline"}
              marginTop={40}
              marginBottom={8}
            />
          </View>
        )}
        <View style={{ zIndex: 10, width: "100%" }}>
          <NotesRow />
        </View>
      </View>
    </View>
  );
});

export default BlockOverview;
